import { render, staticRenderFns } from "./WorkerAdd.vue?vue&type=template&id=31945f32&scoped=true"
import script from "./WorkerAdd.vue?vue&type=script&lang=ts"
export * from "./WorkerAdd.vue?vue&type=script&lang=ts"
import style0 from "./WorkerAdd.vue?vue&type=style&index=0&id=31945f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31945f32",
  null
  
)

export default component.exports